<template>
    <b-card no-body>
        <div class="card-header">
            <div
                class="card-group-title"
            >
                <h4
                    v-if="estimated"
                    class="card-title"
                >
                    {{ $t("org.billing.Estimated Cost") }}
                </h4>
                <h4
                    v-else
                    class="card-title"
                >
                    {{ $t("org.billing.Compared to previous month") }}
                </h4>
            </div>
        </div>
        <b-card-body>
            <template v-if="noData">
                <div class="d-flex justify-content-center align-items-center flex-column text-center">
                    <SVGEmptyIcon/>
                    <span>{{ $t('org.dashboard.No data') }}</span>
                </div>
            </template>
            <template v-else>
                <b-alert
                    v-height-fade
                    :show="status === 200"
                    variant="danger"
                    class="mb-2"
                >
                    <div class="alert-body">
                        <feather-icon
                            icon="InfoIcon"
                            class="mr-50"
                        />
                        {{  estimatedMessage  }}
                    </div>
                </b-alert>
                <b-row>
                    <b-col
                        md="3"
                    >
                        <EstimatedFullCardBarChart
                            :status="status"
                            :themeColors="themeColors"
                            :theme="theme"
                            :cumulativeCost="cumulativeCost"
                            :cumulativeCostStatus="cumulativeCostStatus"
                            :month="month"
                            :prevMonth="prevMonth"
                            :estimated="estimated"
                        ></EstimatedFullCardBarChart>
                    </b-col>
                    <b-col
                        md="2"
                        class="my-auto"
                    >
                        <EstimatedFullCardBarLabel
                            :status="status"
                            :themeColors="themeColors"
                            :theme="theme"
                            :cumulativeCost="cumulativeCost"
                            :estimated="estimated"
                        >
                        </EstimatedFullCardBarLabel>
                    </b-col>
                    <b-col
                        md="7"
                    >
                        <EstimatedFullCardLineChart
                            :status="status"
                            :themeColors="themeColors"
                            :theme="theme"
                            :cumulativeCostStatus="cumulativeCostStatus"
                            :trends="{ currentTrends, pastTrends }"
                            :estimated="estimated"
                        ></EstimatedFullCardLineChart>
                    </b-col>
                </b-row>
            </template>
        </b-card-body>
    </b-card>
</template>

<script>
import { getCurrentInstance, toRefs, computed } from '@vue/composition-api'
import useCommonData from '@/composables/useCommonData'
import EstimatedFullCardBarChart from './EstimatedFullCardBarChart'
import EstimatedFullCardBarLabel from './EstimatedFullCardBarLabel'
import EstimatedFullCardLineChart from './EstimatedFullCardLineChart'
import { heightFade } from '@core/directives/animations'
import SVGEmptyIcon from '@/assets/images/empty.svg'
export default {
    components: {
        EstimatedFullCardBarChart,
        EstimatedFullCardBarLabel,
        EstimatedFullCardLineChart,
        SVGEmptyIcon
    },
    props: [
        'status',
        'themeColors',
        'theme',
        'cumulativeCost',
        'currentTrends',
        'pastTrends',
        'month',
        'prevMonth',
        'estimated',
        'cumulativeCostStatus',
        'noData'
    ],
    directives: {
        'height-fade': heightFade
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const { region, __enMonthMap } = useCommonData()
        const { month, cumulativeCost, estimated, cumulativeCostStatus } = toRefs(props)
        const result = computed(() => {
            const { estimatedCost, prevMonthCost, currentMonthCost } = cumulativeCost.value
            return estimated.value ? estimatedCost - prevMonthCost : currentMonthCost - prevMonthCost
        })

        const estimatedMessage = computed(() => {
            if (estimated.value && (!cumulativeCostStatus.value)) {
                return vm.$t('v4.calculating')
            } else if (estimated.value) {
                return `${vm.$t('v4.estimated', { amount: vm.$_getDollar(cumulativeCost.value.estimatedCost) })} ` +
                    (result.value === 0
                        ? vm.$t('v4.same_as_last_month')
                        : (result.value > 0
                            ? vm.$t('v4.increase_from_last_month', { difference: vm.$_getDollar(Math.abs(result.value)) })
                            : vm.$t('v4.decrease_from_last_month', { difference: vm.$_getDollar(Math.abs(result.value)) })))
            } else {
                return `${vm.$t('v4.final_amount', {
                    month: vm.$t(`v4.${__enMonthMap[month.value.substring(5, 7)]}`),
                    amount: vm.$_getDollar(cumulativeCost.value.currentMonthCost)
                })} ` +
                    (result.value === 0
                        ? vm.$t('v4.same_as_last_month')
                        : (result.value > 0
                            ? vm.$t('v4.increase_from_last_month', { difference: vm.$_getDollar(Math.abs(result.value)) })
                            : vm.$t('v4.decrease_from_last_month', { difference: vm.$_getDollar(Math.abs(result.value)) })))
            }
        })

        return {
            region,
            estimatedMessage
        }
    }
}
</script>
